/** Pilot names: shared by the game (to check a name before asking the server) and the server (which has the last word). */
export const PILOT_NAME_MAX = 8;
export const PILOT_NAME_MIN = 2;

/** Upper case A-Z 0-9 space and hyphen, one space at a time, at most 8 characters, no space at either end. */
export function normPilotName(v: unknown): string {
  return String(v ?? "")
    .toUpperCase()
    .replace(/[^A-Z0-9 \-]/g, "")
    .replace(/ +/g, " ")
    .trim()
    .slice(0, PILOT_NAME_MAX)
    .trim();
}

/** The names the game used to hand out, and the usual placeholders: they identify nobody. */
const GENERIC = /^(P\d{1,3}|PLAYER ?\d*|GUEST ?\d*|NONAME|NO NAME|NAME|DRIVER ?\d*|PILOT ?\d*|ANON|ANONYME|TEST ?\d*|[- ]+)$/;

/** Why a name cannot be a pilot name, or null when it can. */
export function pilotNameError(raw: unknown): "short" | "generic" | null {
  const n = normPilotName(raw);
  if (n.length < PILOT_NAME_MIN) return "short";
  if (GENERIC.test(n)) return "generic";
  return null;
}

/** A pilot code is 128 random bits: 32 hex characters, shown in groups of four. */
export const PILOT_KEY_RE = /^[0-9a-f]{32}$/;
export const normPilotKey = (v: unknown) => String(v ?? "").toLowerCase().replace(/[^0-9a-f]/g, "");
export const formatPilotKey = (k: string) => (k.match(/.{4}/g) ?? []).join("-");
